import { render } from "./CustomerAsk_client.vue?vue&type=template&id=619141f9&scoped=true"
import script from "./CustomerAsk_client.vue?vue&type=script&lang=js"
export * from "./CustomerAsk_client.vue?vue&type=script&lang=js"

import "./CustomerAsk_client.vue?vue&type=style&index=0&id=619141f9&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619141f9"]])

export default __exports__